/*
 * *****************************************************************************
 * File: footer.js (/src/components/footer.js) | frontend
 * Written by Andrea Corsini <andrea@rs1.it>
 * =============================================================
 * Created on Sunday, 14th March 2021 12:26:39 pm
 *
 * Copyright (c) 2020-2021 Andrea Corsini T/A RS1 Project - All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * Modified on Wednesday, 31st March 2021 2:46:35 pm
 * *****************************************************************************
 */
import React from 'react'
import styled from '@emotion/styled'

const Footer = () => {
    const copyYear = new Date().getFullYear()
    return (
        <Container>
            <Inner>
                &copy; {copyYear} <strong>RS1 Project</strong>
            </Inner>
        </Container>
    )
}

export default Footer

const Container = styled.footer`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
    width: 100%;
`

const Inner = styled.div`
    text-align: center;
    height: 100px;
    width: 100%;
    box-sizing: border-box;
    padding: 15px;
    max-width: 1280px;
    color: #444444;
    font-size: 14px;
`
